import React from 'react'

import NewLayout from 'components/Layout/LayoutV1'

import ListingDetailRichContent from './listingDetailRichContent'
import ListingDetailV1 from './listingDetailV1'

const ListingDetail = props => {
  const hasRichContent = !!props.listingDetailRichContent.richContent

  // This div gives ProductInfoCard's useSticky a block-level parentNode.
  // Without it, <buyer-intent-view> (display:inline) wraps the content and its anonymous
  // line box pushes ProductInfoCard below the parent's top, making isSticky fire at load.
  return <div>{hasRichContent ? <ListingDetailRichContent {...props} /> : <ListingDetailV1 {...props} />}</div>
}

ListingDetail.ddogName = 'listing_detail'
ListingDetail.Layout = NewLayout

export default ListingDetail
